// extracted by mini-css-extract-plugin
module.exports = {"countryHeader":"directory-module--countryHeader--3ws1B","schools":"directory-module--schools--1KCpg"};